"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTheme = exports.useOnClickOutside = exports.useKeyPress = void 0;
var react_1 = require("react");
var ThemeProvider_1 = require("../support/ThemeProvider");
var env_1 = require("./env");
var styled_components_1 = require("styled-components");
var useKeyPress = function (targetKey) {
    // State for keeping track of whether key is pressed
    var _a = react_1.useState(false), keyPressed = _a[0], setKeyPressed = _a[1];
    // If pressed key is our target key then set to true
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var downHandler = function (event) {
        if (event.key === targetKey) {
            setKeyPressed(true);
        }
    };
    // If released key is our target key then set to false
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var upHandler = function (event) {
        if (event.key === targetKey) {
            setKeyPressed(false);
        }
    };
    // Add event listeners
    react_1.useEffect(function () {
        window.addEventListener('keydown', downHandler);
        window.addEventListener('keyup', upHandler);
        // Remove event listeners on cleanup
        return function () {
            window.removeEventListener('keydown', downHandler);
            window.removeEventListener('keyup', upHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Empty array ensures that effect is only run on mount and unmount
    return keyPressed;
};
exports.useKeyPress = useKeyPress;
var useOnClickOutside = function (elementRefs, callback) {
    react_1.useEffect(function () {
        if (!(elementRefs === null || elementRefs === void 0 ? void 0 : elementRefs.length))
            return;
        var listener = function (event) {
            var clickInsideElements = false;
            elementRefs.forEach(function (elRef) {
                // Do nothing if clicking ref's element or descendent elements
                if (!elRef.current || elRef.current.contains(event.target)) {
                    clickInsideElements = true;
                }
            });
            if (clickInsideElements)
                return;
            callback(event);
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function () {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    }, [elementRefs, callback]);
};
exports.useOnClickOutside = useOnClickOutside;
var useTheme = function () {
    // In react-native it retrieves theme from our own context
    // On web use Styled-Components hook/context instead
    var contextTheme = react_1.useContext(ThemeProvider_1.ThemeContext);
    var scTheme = styled_components_1.useTheme();
    return env_1.platform === 'web' ? scTheme : contextTheme;
};
exports.useTheme = useTheme;
